import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { HOTEL, NAV, LOCAL_AREAS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-forest-deep text-bone/80" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <img src={HOTEL.logo} alt="Regency Inn & Suites logo" className="h-16 w-auto rounded-md bg-bone p-2 shadow-sm mb-5" />
          <p className="text-sm leading-relaxed max-w-xs">
            A locally owned, independent hotel in Pittsburg, Kansas — clean, comfortable and affordable, with a warm
            welcome for every guest.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-amber mb-5">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {NAV.filter((n) => !n.children).map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="hover:text-amber transition-colors" data-testid={`footer-${n.to.slice(1)}`}>
                  {n.label}
                </Link>
              </li>
            ))}
            <li><Link to="/rooms" className="hover:text-amber transition-colors">Our Rooms</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-amber mb-5">Areas We Serve</h4>
          <ul className="space-y-2.5 text-sm">
            {LOCAL_AREAS.map((a) => (
              <li key={a.slug}>
                <Link to={`/near/${a.slug}`} className="hover:text-amber transition-colors" data-testid={`footer-near-${a.slug}`}>
                  {a.name}
                </Link>
              </li>
            ))}
            <li><Link to="/near" className="hover:text-amber transition-colors">All areas →</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-amber mb-5">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin size={18} className="text-amber shrink-0" /> {HOTEL.fullAddress}
            </li>
            <li>
              <a href={HOTEL.phoneHref} className="flex gap-3 hover:text-amber transition-colors" data-testid="footer-phone">
                <Phone size={18} className="text-amber shrink-0" /> {HOTEL.phone}
              </a>
            </li>
            <li>
              <a href={HOTEL.emailHref} className="flex gap-3 hover:text-amber transition-colors" data-testid="footer-email">
                <Mail size={18} className="text-amber shrink-0" /> {HOTEL.email}
              </a>
            </li>
          </ul>
          <a
            href={HOTEL.booking}
            target="_blank"
            rel="noreferrer"
            className="mt-6 inline-flex rounded-full bg-amber px-6 py-3 text-sm font-medium text-bone hover:bg-amber-deep transition-colors"
            data-testid="footer-book-now"
          >
            Book Direct &amp; Save
          </a>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-bone/50">
          <span>© {new Date().getFullYear()} Regency Inn &amp; Suites, Pittsburg, Kansas. All rights reserved.</span>
          <span>Independently owned &amp; operated · Pet friendly · Free breakfast</span>
        </div>
      </div>
    </footer>
  );
}
